module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('error-dialog-base', {
    ref: "base"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("お使いのブラウザでは"), _c('wbr'), _vm._v("このページを"), _c('wbr'), _vm._v("表示できません。")]), _vm._v(" "), _c("template", {
    tag: "div",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_vm._v("以下のブラウザでこのページを表示可能です。")]), _vm._v(" "), _c('my-compatibleTable')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6176266","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/manager/DbManager/dialogs/DialogNotCompatibleError.vue
// module id = 466
// module chunks = 1